import { Link, NavLink, Outlet, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { journalNav, getJournal, site } from "@/content/site";
import { MaskLines } from "@/components/site/Motion";
import { JournalSidebar } from "@/components/journal/JournalSidebar";
import NotFound from "@/pages/NotFound";

export default function JournalLayout() {
  const { slug } = useParams();
  const journal = getJournal(slug);
  if (!journal) return <NotFound />;
  const nav = journalNav(journal.slug);

  return (
    <div data-testid={`journal-layout-${journal.slug}`}>
      <section className="relative grain border-b border-[var(--line)] bg-[var(--paper-2)] overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-10 lg:pt-14 pb-10 grid grid-cols-[88px_1fr] sm:grid-cols-[120px_1fr] gap-6 sm:gap-10 items-end">
          <motion.div initial={{ clipPath: "inset(100% 0 0 0)" }} animate={{ clipPath: "inset(0% 0 0 0)" }} transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}>
            <img src={journal.cover} alt={`${journal.title} cover`} className="w-full aspect-[2/3] object-cover shadow-[0_20px_40px_-18px_rgba(0,0,0,0.4)]" />
          </motion.div>
          <div>
            <nav aria-label="Breadcrumb" className="text-sm text-[var(--ink-muted)] mb-4">
              <Link to="/" className="link-u" data-testid="breadcrumb-home">{site.name}</Link> <span aria-hidden="true">/</span> <span className="text-[var(--ink)]">{journal.abbr}</span>
            </nav>
            <MaskLines as="p" lines={[journal.title]} className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]" />
          </div>
        </div>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <nav aria-label={`${journal.abbr} sections`} className="flex gap-1 overflow-x-auto -mb-px [scrollbar-width:none]" data-testid="journal-subnav">
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} end className={({ isActive }) => `whitespace-nowrap px-4 py-4 text-sm border-b-2 transition-colors ${isActive ? "border-[var(--emerald)] text-[var(--emerald)] font-semibold" : "border-transparent text-[var(--ink-muted)] hover:text-[var(--ink)]"}`} data-testid={`journal-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-20 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-8 min-w-0"><Outlet context={{ journal }} /></div>
        <div className="lg:col-span-4"><JournalSidebar journal={journal} /></div>
      </div>
    </div>
  );
}
